<template>
  <div class="card-info-basicas-produto-repeticao">
    <g-titulo-steps
    titulo="INFORMAÇÕES BÁSICAS"
    subtitulo="Forneça informações básicas, como: nome, quantidade e data de carregamento"
    :imagemEmpresa = imagemEmpresa
    />
    <g-form>

      <div class="infoBasicas-conteudo espacamento-fluxos">
        <div class="img-container-mobile">
          <div class="img-box-mobile">
            <PImage :imageStyle="styleImg" v-on:error="erro($event)" :src="caminhoImagem" :preview="true">
            </PImage>
            <div class="img-info-mobile" v-if="this.styleImg.includes('100')"> NENHUMA IMAGEM DISPONÍVEL! </div>
          </div>
        </div>

        <div class="infoBasicas-nome-produto">
          <div class="nome-produto-titulo titulo-conteudo-fluxos"> Selecione o Produto <strong class="asterisco-obrigatorio">*</strong></div>
          <PDropDown
          class="nome-produto-input input-label"
          :filter="true"
          @change="chamarImagem"
          v-model="ProdutoSelecionado"
          :options="ProdutoArray"
          :disabled="reorcamento || copiaOrcamentoQuantidade"
          :filterFields="['labelProduto', 'componentes']"
          optionLabel="labelProduto"
          optionValue="produtoId"
          placeholder="Selecione"
          @filter="buscarProdutos($event.value)"
          >
            <template #option="slotProps">
              <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
            </template>
          </PDropDown>
        </div>

        <div class="container-quantidade-dataCarreg">
          <div class="quantidade-data-carregamento">
            <div class="infoBasicas-quantidade">
              <div class="quantidade-titulo titulo-conteudo-fluxos"> Quantidade <strong class="asterisco-obrigatorio">*</strong> </div>
              <PInputNumber
              class="quantidade-input input-label"
              @keypress="camponumero"
              v-model="quantidade"
              :disabled="reorcamento"
              type="int"
              :max="99_999_999"
              />
            </div>

            <div class="infoBasicas-data-carregamento">
              <div class="data-carregamento-titulo titulo-conteudo-fluxos"> Dt. de Carregamento</div>
              <div class="botao-input-adicionar-data">
                <div class="data-carregamento">
                  <g-date-input
                  class="data-carregamento-input input-label"
                  tamanhobotao = "45px"
                  alturabotao = "40px"
                  alturainput = "42px"
                  largurainput="100%"
                  v-model="dataCarregamento"
                  :disabled="reorcamento"
                  ></g-date-input>
                </div>

                <g-button
                class="add-box"
                alturainput = "42px"
                tamanhobotao = "35px"
                tipo="amarelo"
                tamanhoIcone="15px"
                @click="addRow"
                :somenteIcone="true"
                :sombreado="false"
                v-if="this.reorcamento || !(this.infoEntregaProduto.length == 2)"
                :hidden=" reorcamento || copiaOrcamentoQuantidade"
                >
                  <i class="pi pi-minus" v-if="!ehAdicao"></i>
                  <i class="pi pi-plus" v-if="ehAdicao"></i>
                </g-button>
              </div>
            </div>
          </div>

          <div class="quantidade-data-carregamento" v-for="(data, index) in infoEntregaProduto" :key="data">
            <div class="infoBasicas-quantidade">
              <div class="quantidade-titulo titulo-conteudo-fluxos"> Quantidade </div>
              <PInputNumber
              class="quantidade-input input-label"
              @keypress="camponumero"
              @input="camponumero"
              v-model="infoEntregaProduto[index].quantidade"
              :disabled="reorcamento"
              type="int"
              :max="99_999_999"
              />
            </div>

            <div class="infoBasicas-data-carregamento">
              <div class="data-carregamento-titulo titulo-conteudo-fluxos"> Dt. de Carregamento </div>
              <div class="botao-input-adicionar-data">
                <div class="data-carregamento">
                  <g-date-input
                  class="data-carregamento-input input-label"
                  tamanhobotao = "45px"
                  alturabotao = "40px"
                  alturainput = "42px"
                  largurainput="100%"
                  :key="numberRow"
                  v-model="infoEntregaProduto[index].dataCarregamento"
                  :disabled="reorcamento"
                  ></g-date-input>
                </div>

                <g-button
                class="add-box"
                tipo="amarelo"
                tamanhoIcone="15px"
                :somenteIcone="true"
                :sombreado="false"
                @click="deleteRow(index)"
                v-if="!this.reorcamento"
                :hidden="reorcamento"
                >
                  <i class="pi pi-minus"></i>
                </g-button>
              </div>
            </div>
          </div>
            <!-- <div class="checkbox-emissao">
              <PCheckBox id="emissao" :binary="true" v-model="emissaoPedido"/>
              <label class="checkboxGerais label-checkbox"> Orçamento para emissão de pedido </label>
            </div> -->
        </div>
      </div>
    </g-form>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="step4" 
        ref="botaoContinuar"
        >
          CONTINUAR
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="voltarstep2" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>
    <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import InfoBasicasRepeticao from './InfoBasicasRepeticao.js'
export default InfoBasicasRepeticao
</script>

<style scoped>

.imagem_empresa{
  display: flex;
}
.espacamento-fluxos {
  margin-top: 30px;
}

.invisivel {
  visibility: hidden;
}

.titulo-conteudo-fluxos {
  margin-top: 20px;
}

.img-container-mobile, .img-container-desktop {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
}

.img-container-mobile, .img-box-mobile, .img-container-desktop, .img-box-desktop {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-box-mobile, .img-box-desktop {
  width: auto;
  height: fit-content;
  flex-direction: column;
}

.img-info-mobile {
  font-size: 13px;
  font-family: "MontSerrat";
  letter-spacing: 0px;
  color: #CECECE;
  width: auto;
  margin: 10px 10px;
}

.botao-input-adicionar-data {
  display: grid;
  grid-template-columns: 8.5fr 45px;
  grid-template-rows: auto;
  grid-column-gap: 8px; 
}

.add-box {
  width: 45px;
  justify-self: self-end;
  align-self: flex-start;
}

@media (min-width: 310px) {
.infoBasicas-conteudo, .quantidade-data-carregamento  {
  display: flex;
  flex-direction: column;
}

.img-container-mobile, .img-container-desktop {
  height: 24vh;
  width: 100%;
}
}

@media (max-width:368px){

}

@media (min-width: 500px) {
.quantidade-data-carregamento {
  display: grid;
  grid-template-columns: 1.5fr 3fr;
  grid-column-gap: 15px;
}
}

@media (min-width: 600px) {

}

@media (min-width: 801px) {
.infoBasicas-conteudo {
display: grid;
grid-template-columns: 50% minmax(4em, 1fr);
grid-template-rows: repeat(3, auto);
grid-column-gap: 20px;
}

.img-container-mobile { grid-area: 1 / 1 / 3 / 3; }
.infoBasicas-nome-produto { grid-area: 3 / 1 / 4 / 2; }
.container-quantidade-dataCarreg { grid-area: 3 / 2 / 4 / 3; }
}

@media (min-width: 1025px) {
.infoBasicas-conteudo {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: 5.3em minmax(4em, 1fr);
}
.img-container-mobile { grid-area: 1 / 3 / 3 / 5; }
.infoBasicas-nome-produto { grid-area: 1 / 1 / 2 / 3; }
.container-quantidade-dataCarreg { grid-area: 2 / 1 / 3 / 3; }

.img-container-mobile, .img-container-desktop {
  height: auto;
  width: 100%;
  min-height: 18em;
}
}

@media (min-width: 1281px) {
.infoBasicas-conteudo {
  grid-column-gap: 40px;
}

}

@media (min-width:1500px) {
}

</style>
